/* eslint-disable consistent-return */
import { notification } from 'antd';
import { getPropsFromUrl, lodashFilter } from 'components/hoc/index';
import filtersToApi from 'components/page/ObjectFilter/components/ViewActions/flow/utils';
import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Enums from 'utils/EnumsManager';
import { setPreview } from 'views/ReportPreview/flow/actions';
import { resetModalSorter } from 'views/ReportTableSetup/flow/actions';
import { resetSorterIfNecessary } from 'views/ReportTableSetup/utils/checkReportSorter';
import { trySaveNewReport, tryUpdateReport } from '../../../flow/actions';
import Buttons from '../components/Buttons';

const { REPORTS, DROPZONES } = Enums;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;
const targetZones = [GROUPS, OTHERS, AGGREGATES];
const { GROUPSORTER, ORTHERSSORRTER } = REPORTS.SORTER;

const defaultProps = {
  activeReportFolder: {}
};
const propTypes = {
  activeReportFolder: PropTypes.object
};

class Actions extends PureComponent {
  componentWillUpdate(nextProps) {
    const { newReportId, history, objectType } = this.props;
    if (newReportId !== nextProps.newReportId) {
      history.push(
        `/reports/report-setup/${objectType}/${nextProps.newReportId}`
      );
    }
  }

  getSorterInfo = (sorterType) => {
    const { sorter, selectedCols } = this.props;
    const { name, action, direction } = sorter[sorterType].selectedValue;
    let field_type = '';
    selectedCols.forEach(col => {
      if (name.value === col.name) {
        switch (col.belongTo) {
          case GROUPS:
            field_type = 'group_by';
            break;

          case OTHERS:
            field_type = 'others';
            break;

          case AGGREGATES:
            field_type = 'aggregations';
            break;

          default:
            break;
        }
      }
    });
    return !_.isEmpty(name.value) ? [{
      field_name: name.value,
      suffix_key: !_.isEmpty(action.value) ? action.value : '',
      direction,
      field_type,
    }] : [];
  }

  getGroupColumns = () =>
    this.props.usedColumns
      .filter(c => c.belongTo === GROUPS)
      .map(g => {
        const group = {
          field_name: g.name
        };
        if (g.type) {
          group.type = g.actions;
        }
        return group;
      });
  getAggregateColumns = () =>
    this.props.usedColumns
      .filter(c => c.belongTo === AGGREGATES)
      .map(a => ({
        field_name: a.name,
        functions: a.actions
      }));
  getOtherColumns = () =>
    this.props.usedColumns.filter(c => c.belongTo === OTHERS).map(o => o.name);
  dataToApi = () => ({
    name: this.props.reportName,
    type: this.props.objectType,
    format: this.props.reportFormat,
    setup_properties: {
      group_by: this.getGroupColumns(),
      selectors: this.getOtherColumns(),
      aggregations: this.getAggregateColumns(),
      filters: filtersToApi(this.props.filters),
      condition_logic: this.props.logic.toUpperCase(),
      table_order_by: this.getSorterInfo(GROUPSORTER),
      in_group_order_by: this.getSorterInfo(ORTHERSSORRTER),
    }
  });

  showCriteriaErrMsg = key => {
    const { intl } = this.props;
    return notification.error({
      duration: 3,
      message: intl.formatMessage({
        id: `global.errors.${key}`
      })
    });
  }

  checkCriteriaAndLogic = () => {
    const { filters, logic } = this.props;
    if (!_.isArray(filters)) {
      return false;
    }
    const isAnyInvalid = filters.some(f => !f.isValid());
    if (isAnyInvalid) {
      this.showCriteriaErrMsg('fieldAndConditionRequired');
      return false;
    }
    if (filters.length > 0 && !logic) {
      this.showCriteriaErrMsg('filterNumRequired');
      return false;
    }
    return true;
  }

  handleSaveClick = async () => {
    const { location, sorter, selectedCols, resetModalSorter } = this.props;
    const { search } = location;
    // We need to check the filter before dataToAPI, this avoid error that there are filters, but the filters are empty.
    if (!this.checkCriteriaAndLogic()) return;
    // check if the sorter match the selected fields, if not, reset all the sorters to initial.
    await resetSorterIfNecessary(sorter, selectedCols, resetModalSorter);

    const urlProps = queryString.parse(search);
    const payload = this.dataToApi();

    const error = this.firstErrorOrDefault(payload);
    if (error) {
      return notification.error({
        duration: 3,
        message: this.props.intl.formatMessage({
          id: `page.ReportFilters.errors.${error.key}`
        })
      });
    }

    // FIXME: this is a temp solution, because we didn't find the reason why the route change doesn't apply the new match prop to this instance.
    //        It may need further research on update and react router.
    //        Now, we use a workaround to check if 'newReportId' has value or not.
    //        But this solution may be broken if we have more entry points from somewhere else.
    if (this.props.newReportId === '') {
      if (this.props.reportId !== 'new') {
        delete payload.format;
        return this.props.tryUpdateReport(this.props.reportId, payload);
      }
      const folderId = urlProps.folderId || -1;
      return this.props.trySaveNewReport(folderId, payload);
    }
    delete payload.format;
    return this.props.tryUpdateReport(this.props.newReportId, payload);
  };
  handlePreviewClick = () => this.props.setPreview(this.props.usedColumns);
  // TODO: add validation
  firstErrorOrDefault = data => {
    if (!data.name) {
      return {
        key: 'name'
      };
    }
    if (!data.type) {
      return {
        key: 'type'
      };
    }
    if (!data.format) {
      return {
        key: 'format'
      };
    }
    if (data.setup_properties.group_by.length < 1) {
      return {
        key: 'group'
      };
    }
    return null;
  };

  render() {
    return (
      <Buttons
        onSave={this.handleSaveClick}
        onPreview={this.handlePreviewClick}
      />
    );
  }
}

const mapStateToProps = ({
  global,
  reportSetup,
  FilterCriteria__REFACTORED,
  reportList
}) => ({
  lang: global.language,
  reportName: reportSetup.setup.name,
  reportFormat: reportSetup.setup.format,
  columns: reportSetup.sider.availableColumns,
  filters: FilterCriteria__REFACTORED.criteria.criteria,
  logic: FilterCriteria__REFACTORED.logic,
  newReportId: reportSetup.setup.newReportId,
  selectedCols: reportSetup.sider.selectedCols,
  sorter: reportSetup.sorter,
  activeReportFolder: [
    ...reportList.folders.report,
    ...reportList.folders.dashboard
  ].find(f => f.isActive)
});
const mapDispatchToProps = {
  setPreview,
  trySaveNewReport,
  tryUpdateReport,
  resetModalSorter
};
const enhancers = compose(
  withRouter,
  getPropsFromUrl(['objectType', 'reportId']),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  lodashFilter(
    'selectedCols',
    'usedColumns',
    c => c && targetZones.indexOf(c.belongTo) > -1
  ),
  injectIntl
);
Actions.defaultProps = defaultProps;
Actions.propTypes = propTypes;
export default enhancers(Actions);



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/Actions/container/index.jsx